import { useIntl } from 'react-intl';
import { useHistory, useLocation } from 'react-router-dom';

import { appStrings, getRouteId } from '../i18n';
import scrollTo from '../utils/scrollTo';

const useLocalization = () => {
    const { pathname, search } = useLocation();
    const history = useHistory();
    const { formatMessage, locale } = useIntl();

    const getMatchingRoute = (_locale) => {
        const routeId = getRouteId(pathname);
        /**
         * Find the matching route for the new language
         */
        const matchingRoute = appStrings[_locale][routeId];

        /**
         * Return localized route with query string
         */
        return `/${_locale}` + matchingRoute + search;
    };

    /**
     * Set application URL to route specified by @id
     * @param {String} id - route ID
     * @param {{queryParams: Object, state: Object }} [options]
     */
    const localizedPush = (id, options) => {
        scrollTo(0, 0);
        let url = `/${locale}` + formatMessage({ id });

        if (options && options.queryParams) {
            url += '?' + new URLSearchParams(options.queryParams).toString();
        }

        history.push(url, {
            from: { pathname },
            state: options && options.state ? options.state : null,
        });
    };

    return { getMatchingRoute, localizedPush };
};

export default useLocalization;
